export default __webpack_public_path__ + "static/media/Toilet - Coral.60971ccf.svg";